import ControlTab from './container'

export default ControlTab